// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
* VARIABLES
*/
/*
* MIXINS
*/
.Row {
  display: block;
  padding: 1.5vh 0;
}
@media (min-width: 768px) {
  .Row {
    padding: 3vh 0;
  }
}
.Row__title {
  margin-bottom: 1rem;
  padding: 0 4%;
  font-size: 16px;
  line-height: 1.25vw;
  text-align: left;
  display: inline-block;
}
@media (min-width: 768px) {
  .Row__title {
    font-size: 18px;
  }
}
@media (min-width: 1330px) {
  .Row__title {
    font-size: 1.2vw;
  }
}
.Row__title a {
  color: #f2f2f2;
  text-decoration: none;
}
.Row__title:hover .Row__showmore {
  opacity: 1;
  max-width: 200px;
  transform: translate(1vw, 0);
}
.Row__showmore {
  font-size: 12px;
  line-height: 1vw;
  display: inline-flex;
  align-items: center;
  color: #f2f2f2;
  white-space: nowrap;
  opacity: 0;
  max-width: 0;
  transform: translateZ(0);
  transition: max-width 450ms, opacity 450ms, transform 750ms;
}
@media (min-width: 768px) {
  .Row__showmore {
    font-size: 14px;
  }
}
@media (min-width: 1330px) {
  .Row__showmore {
    font-size: 0.8vw;
  }
}
.Row__not-loaded {
  padding: 0 4%;
}
@media (min-width: 768px) {
  .Row .swiper-wrapper:hover .swiper-slide {
    transform: translateX(-15%);
    opacity: 0.3;
  }
  .Row .swiper-wrapper:hover .swiper-slide:hover {
    transform: scale(1.3) !important;
    z-index: 1;
    opacity: 1;
  }
  .Row .swiper-wrapper:hover .swiper-slide:hover ~ .swiper-slide {
    transform: translateX(15%);
  }
  .Row .swiper-wrapper.is-left:hover .swiper-slide:hover ~ .swiper-slide {
    transform: translateX(28%);
  }
  .Row .swiper-wrapper.is-right:hover .swiper-slide {
    transform: translateX(-30%);
    opacity: 0.3;
  }
  .Row .swiper-wrapper.is-right:hover .swiper-slide:hover {
    transform: scale(1.3) !important;
    z-index: 1;
    opacity: 1;
  }
  .Row .swiper-wrapper.is-right:hover .swiper-slide:hover ~ .swiper-slide {
    transform: translateX(0%);
  }
}
.Row .swiper-slide {
  display: inline-flex;
  transform: scale(1);
  transition: transform 0.3s ease-out, opacity 0.3s ease-out;
}
@media (min-width: 330px) {
  .Row .swiper-slide:nth-child(1n) {
    transform-origin: initial;
  }
  .Row .swiper-slide:nth-child(2n+1) {
    transform-origin: left;
  }
  .Row .swiper-slide:nth-child(2n+2) {
    transform-origin: right;
  }
}
@media (min-width: 625px) {
  .Row .swiper-slide:nth-child(1n) {
    transform-origin: initial;
  }
  .Row .swiper-slide:nth-child(3n+1) {
    transform-origin: left;
  }
  .Row .swiper-slide:nth-child(3n+3) {
    transform-origin: right;
  }
}
@media (min-width: 998px) {
  .Row .swiper-slide:nth-child(1n) {
    transform-origin: initial;
  }
  .Row .swiper-slide:nth-child(4n+1) {
    transform-origin: left;
  }
  .Row .swiper-slide:nth-child(4n+4) {
    transform-origin: right;
  }
}
@media (min-width: 1378px) {
  .Row .swiper-slide:nth-child(1n) {
    transform-origin: initial;
  }
  .Row .swiper-slide:nth-child(6n+1) {
    transform-origin: left;
  }
  .Row .swiper-slide:nth-child(6n+6) {
    transform-origin: right;
  }
}
.Row .swiper-container {
  overflow: initial;
  width: 100%;
  height: auto;
  padding: 0 4%;
}
.Row .swiper-container:hover .swiper-pagination {
  opacity: 1;
}
.Row .swiper-pagination {
  top: -35px;
  right: 4.5%;
  left: initial !important;
  bottom: initial !important;
  width: auto !important;
  opacity: 0;
  z-index: 1;
  transform: none;
  transition: opacity 0.2s ease-out;
}
.Row .swiper-pagination-bullet {
  width: 12px;
  height: 4px;
  display: inline-block;
  margin: 0 !important;
  margin-left: 2px !important;
  border-radius: 0;
  opacity: 1;
  background-color: #4d4d4d;
  transition: all 0.2s ease-in-out;
}
.Row .swiper-pagination-bullet-active {
  background-color: #aaa;
  height: 5px;
}
.Row__slider--mask {
  position: absolute;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #f2f2f2;
  width: 4%;
  height: 100%;
  background: rgba(16, 16, 17, 0.5);
  z-index: 10;
}
.Row__slider--mask.left {
  left: 0;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
}
.Row__slider--mask.right {
  right: 0;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
}
.Row__slider--mask.left:hover .Row__slider--mask-icon, .Row__slider--mask.right:hover .Row__slider--mask-icon {
  opacity: 1;
  transform: scale(1.3);
}
.Row__slider--mask-icon {
  opacity: 0;
  transform: scale(0.9);
  transition: opacity 0.2s ease-out, transform 0.2s ease-out;
}
.Row__slider--mask.swiper-button-disabled {
  opacity: 0.2;
}
.Row__slider--mask:hover {
  cursor: pointer;
}
.Row__slider--mask:hover ~ .swiper-container .swiper-pagination {
  opacity: 1;
}`, "",{"version":3,"sources":["webpack://./src/scss/_mixin.scss","webpack://./src/components/Row/row.scss","webpack://./src/scss/_variables.scss"],"names":[],"mappings":"AAAA;;CAAA;AAKA;;CAAA;ACFA;EACI,cAAA;EACA,gBAAA;AAIJ;ADmEQ;ECzER;IAKQ,cAAA;EAKN;AACF;AAHI;EACI,mBAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,qBAAA;AAKR;ADsDQ;ECjEJ;IASQ,eAAA;EAMV;AACF;ADiDQ;ECjEJ;IAYQ,gBAAA;EAQV;AACF;AANQ;EACI,cC3BJ;ED4BI,qBAAA;AAQZ;AAJY;EACI,UAAA;EACA,gBAAA;EACA,4BAAA;AAMhB;AADI;EACI,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,mBAAA;EACA,cC7CA;ED8CA,mBAAA;EACA,UAAA;EACA,YAAA;EACA,wBAAA;EACA,2DAAA;AAGR;ADuBQ;ECpCJ;IAaQ,eAAA;EAIV;AACF;ADkBQ;ECpCJ;IAgBQ,gBAAA;EAMV;AACF;AAHI;EACI,aAAA;AAKR;ADUQ;ECTQ;IACI,2BAAA;IACA,YAAA;EAElB;EAAkB;IACI,gCAAA;IACA,UAAA;IACA,UAAA;EAEtB;EAAsB;IACI,0BAAA;EAE1B;EAQ0B;IACI,0BAAA;EAN9B;EAekB;IACI,2BAAA;IACA,YAAA;EAbtB;EAesB;IACI,gCAAA;IACA,UAAA;IACA,UAAA;EAb1B;EAe0B;IACI,yBAAA;EAb9B;AACF;AAqBI;EACI,oBAAA;EACA,mBAAA;EACA,0DAAA;AAnBR;ADxBQ;EC8CI;IACI,yBAAA;EAnBd;EAqBU;IACI,sBAAA;EAnBd;EAqBU;IACI,uBAAA;EAnBd;AACF;ADnCQ;ECyDI;IACI,yBAAA;EAnBd;EAqBU;IACI,sBAAA;EAnBd;EAqBU;IACI,uBAAA;EAnBd;AACF;AD9CQ;ECoEI;IACI,yBAAA;EAnBd;EAqBU;IACI,sBAAA;EAnBd;EAqBU;IACI,uBAAA;EAnBd;AACF;ADzDQ;EC+EI;IACI,yBAAA;EAnBd;EAqBU;IACI,sBAAA;EAnBd;EAqBU;IACI,uBAAA;EAnBd;AACF;AAuBI;EACI,iBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;AArBR;AAwBY;EACI,UAAA;AAtBhB;AA2BI;EACI,UAAA;EACA,WAAA;EACA,wBAAA;EACA,0BAAA;EACA,sBAAA;EACA,UAAA;EACA,UAAA;EACA,eAAA;EACA,iCAAA;AAzBR;AA2BQ;EACI,WAAA;EACA,WAAA;EACA,qBAAA;EACA,oBAAA;EACA,2BAAA;EACA,gBAAA;EACA,UAAA;EACA,yBAAA;EACA,gCAAA;AAzBZ;AA2BY;EACI,sBAAA;EACA,WAAA;AAzBhB;AA+BQ;EACI,kBAAA;EACA,MAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cCxNJ;EDyNI,SAAA;EACA,YAAA;EACA,iCAAA;EACA,WAAA;AA7BZ;AA+BY;EACI,OAAA;EACA,4BAAA;EACA,+BAAA;AA7BhB;AA+BY;EACI,QAAA;EACA,2BAAA;EACA,8BAAA;AA7BhB;AAmCoB;EACI,UAAA;EACA,qBAAA;AAjCxB;AAsCY;EACI,UAAA;EACA,qBAAA;EACA,0DAAA;AApChB;AAuCY;EACI,YAAA;AArChB;AAwCY;EACI,eAAA;AAtChB;AAyCoB;EACI,UAAA;AAvCxB","sourcesContent":["/*\n* VARIABLES\n*/\n$breakpoints: (ll: 1450px, lg: 1024px, md: 768px, sm: 640px, xs: 400px) !default;\n\n/*\n* MIXINS\n*/\n@mixin mq($min: null, $max: null) {\n    $min-type: type-of($min);\n    $max-type: type-of($max);\n\n    @if $min-type==string {\n        @if $min==xs {\n            $min: \"(min-width: #{map-get($breakpoints, xs)})\";\n        }\n        @else if $min==sm {\n            $min: \"(min-width: #{map-get($breakpoints, sm)})\";\n        }\n        @else if $min==md {\n            $min: \"(min-width: #{map-get($breakpoints, md)})\";\n        }\n        @else if $min==lg {\n            $min: \"(min-width: #{map-get($breakpoints, lg)})\";\n        }\n        @else if $min==ll {\n            $min: \"(min-width: #{map-get($breakpoints, ll)})\";\n        }\n        @else {\n            @warn \"mq mixin supports: sm, md, lg, ll\";\n        }\n    }\n    @else if $min-type==number {\n        $min: \"(min-width: #{$min})\";\n    }\n\n    @if $max-type==string {\n        @if $max==xs {\n            $max: \"(max-width: #{map-get($breakpoints, xs) - 1})\";\n        }\n        @else if $max==sm {\n            $max: \"(max-width: #{map-get($breakpoints, sm) - 1})\";\n        }\n        @else if $max==md {\n            $max: \"(max-width: #{map-get($breakpoints, md) - 1})\";\n        }\n        @else if $max==lg {\n            $max: \"(max-width: #{map-get($breakpoints, lg) - 1})\";\n        }\n        @else if $max==ll {\n            $max: \"(max-width: #{map-get($breakpoints, ll) - 1})\";\n        }\n        @else {\n            @warn \"mq mixin supports: xs, sm, md, lg, ll\";\n        }\n    }\n\n    @else if $max-type==number {\n        $max: \"(max-width: #{$max})\";\n    }\n\n    $query: false;\n    @if $min and $max {\n        $query: \"#{$min} and #{$max}\";\n    }\n    @else if $min {\n        $query: \"#{$min}\";\n    }\n    @else if $max {\n        $query: \"#{$max}\";\n    }\n\n    @if (not $query) {\n        @warn \"Invalid media query\";\n    }\n    @else {\n        @media #{$query} {\n            @content;\n        }\n    }\n}\n\n@mixin mob() {\n    @include mq(null, md) {\n        @content;\n    }\n}\n\n@mixin smart() {\n    @include mq(null, sm) {\n        @content;\n    }\n}\n\n@mixin tab-portrait() {\n    @include mq(sm, md) {\n        @content;\n    }\n}\n\n@mixin tab-landscape() {\n    @include mq(md, lg) {\n        @content;\n    }\n}\n\n@mixin desk() {\n    @include mq(lg) {\n        @content;\n    }\n}","@import '../../scss/mixin';\n@import '../../scss/variables';\n\n.Row {\n    display: block;\n    padding: 1.5vh 0;\n\n    @include mq('md'){\n        padding: 3vh 0;\n    }\n\n    &__title {\n        margin-bottom: 1rem;\n        padding: 0 4%;\n        font-size: 16px;\n        line-height: 1.25vw;\n        text-align: left;\n        display: inline-block;\n\n        @include mq('md'){\n            font-size: 18px;\n        }\n        @include mq(1330px){\n            font-size: 1.2vw;\n        }\n\n        a {\n            color: $white;\n            text-decoration: none;\n        }\n\n        &:hover {\n            .Row__showmore {\n                opacity: 1;\n                max-width: 200px;\n                transform: translate(1vw,0);\n            }\n        }\n    }\n\n    &__showmore {\n        font-size: 12px;\n        line-height: 1vw;\n        display: inline-flex;\n        align-items: center;\n        color: $white;\n        white-space: nowrap;\n        opacity: 0;\n        max-width: 0;\n        transform: translateZ(0);\n        transition: max-width 450ms, opacity 450ms, transform 750ms;\n\n        @include mq('md'){\n            font-size: 14px;\n        }\n        @include mq(1330px){\n            font-size: 0.8vw;\n        }\n    }\n\n    &__not-loaded {\n        padding: 0 4%;\n    }\n\n    .swiper-wrapper {\n        @include mq('md') {\n            &:hover {\n                .swiper-slide {\n                    transform: translateX(-15%);\n                    opacity: 0.3;\n\n                    &:hover {\n                        transform: scale(1.3) !important;\n                        z-index: 1;\n                        opacity: 1;\n\n                        ~ .swiper-slide {\n                            transform: translateX(15%);\n                        }\n                    }\n                }\n            }\n\n            &.is-left {\n                &:hover {\n                    .swiper-slide {\n                        &:hover {\n                            ~ .swiper-slide {\n                                transform: translateX(28%);\n                            }\n                        }\n                    }\n                }\n            }\n\n            &.is-right {\n                &:hover {\n                    .swiper-slide {\n                        transform: translateX(-30%);\n                        opacity: 0.3;\n\n                        &:hover {\n                            transform: scale(1.3) !important;\n                            z-index: 1;\n                            opacity: 1;\n\n                            ~ .swiper-slide {\n                                transform: translateX(0%);\n                            }\n                        }\n                    }\n                }\n            }\n        }\n    }\n\n    .swiper-slide {\n        display: inline-flex;\n        transform: scale(1);\n        transition: transform 0.3s ease-out, opacity 0.3s ease-out;\n\n        @include mq(330px) {\n            &:nth-child(1n) {\n                transform-origin: initial;\n            }\n            &:nth-child(2n+1) {\n                transform-origin: left;\n            }\n            &:nth-child(2n+2) {\n                transform-origin: right;\n            }\n        }\n        @include mq(625px) {\n            &:nth-child(1n) {\n                transform-origin: initial;\n            }\n            &:nth-child(3n+1) {\n                transform-origin: left;\n            }\n            &:nth-child(3n+3) {\n                transform-origin: right;\n            }\n        }\n        @include mq(998px) {\n            &:nth-child(1n) {\n                transform-origin: initial;\n            }\n            &:nth-child(4n+1) {\n                transform-origin: left;\n            }\n            &:nth-child(4n+4) {\n                transform-origin: right;\n            }\n        }\n        @include mq(1378px) {\n            &:nth-child(1n) {\n                transform-origin: initial;\n            }\n            &:nth-child(6n+1) {\n                transform-origin: left;\n            }\n            &:nth-child(6n+6) {\n                transform-origin: right;\n            }\n        }\n    }\n\n    .swiper-container {\n        overflow: initial;\n        width: 100%;\n        height: auto;\n        padding: 0 4%;\n\n        &:hover {\n            .swiper-pagination {\n                opacity: 1;\n            }\n        }\n    }\n\n    .swiper-pagination {\n        top: -35px;\n        right: 4.5%;\n        left: initial !important;\n        bottom: initial !important;\n        width: auto !important;\n        opacity: 0;\n        z-index: 1;\n        transform: none;\n        transition: opacity 0.2s ease-out;\n\n        &-bullet {\n            width: 12px;\n            height: 4px;\n            display: inline-block;\n            margin: 0 !important;\n            margin-left: 2px !important;\n            border-radius: 0;\n            opacity: 1;\n            background-color: #4d4d4d;\n            transition: all 0.2s ease-in-out;\n\n            &-active {\n                background-color: #aaa;\n                height: 5px;\n            }\n        }\n    }\n\n    &__slider {\n        &--mask {\n            position: absolute;\n            top: 0;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            color: $white;\n            width: 4%;\n            height: 100%;\n            background: rgba($grey, 0.5);\n            z-index: 10;\n\n            &.left {\n                left: 0;\n                border-top-right-radius: 5px;\n                border-bottom-right-radius: 5px;\n            }\n            &.right {\n                right: 0;\n                border-top-left-radius: 5px;\n                border-bottom-left-radius: 5px;\n            }\n\n            &.left,\n            &.right {\n                &:hover {\n                    .Row__slider--mask-icon {\n                        opacity: 1;\n                        transform: scale(1.3);\n                    }\n                }\n            }\n\n            &-icon {\n                opacity: 0;\n                transform: scale(0.9);\n                transition: opacity 0.2s ease-out, transform 0.2s ease-out;\n            }\n\n            &.swiper-button-disabled {\n                opacity: 0.2;\n            }\n\n            &:hover {\n                cursor: pointer;\n\n                ~ .swiper-container {\n                    .swiper-pagination {\n                        opacity: 1;\n                    }\n                }\n            }\n        }\n    }\n}","$white: #f2f2f2;\n$pure-black: #030303;\n$light-black: #181818;\n$black: #141414;\n$red: #e50914;\n$grey: #101011;\n$blue-google: #1356c7;\n\n$main-font: 'Inter', sans-serif;\n$fakeflix-font: 'Bebas Neue', cursive;"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
